import React from 'react';
import {
  Fade,
  Grid,
  Card,
  CardContent,
  Box,
  Typography,
} from '@mui/material';
import Zoom from '@mui/material/Zoom';
import {
  ShowChart as ShowChartIcon,
  CalendarToday as CalendarTodayIcon,
} from '@mui/icons-material';
import Chart from 'react-apexcharts';

const TrendsTab = ({ data = {} }) => (
  <Fade in timeout={500}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Card
          sx={{
            p: 3,
            boxShadow: '0px 2px 6px 0px rgba(13, 10, 44, 0.08)',
            borderRadius: 2,
            transition: 'all 0.3s ease-in-out',
            '&:hover': { boxShadow: '0px 4px 12px 0px rgba(13, 10, 44, 0.12)', transform: 'translateY(-2px)' },
          }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, p: 2, bgcolor: 'warning.lighter', borderRadius: 1 }}>
              <ShowChartIcon sx={{ mr: 1, color: 'warning.main' }} />
              <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.titles' }}>
                Monthly Trends Over Time
              </Typography>
            </Box>
            <CardContent sx={{ p: 3, pt: 0 }}>
              <Chart
                options={{
                  chart: {
                    type: 'line',
                    animations: { enabled: true, easing: 'easeinout', speed: 1000 },
                  },
                  xaxis: {
                    categories: data?.monthly?.map((month) => month.month) || [],
                    labels: { style: { fontSize: '12px', fontWeight: 500 } },
                  },
                  yaxis: {
                    title: {
                      text: 'Count',
                      style: { fontSize: '14px', fontWeight: 600 },
                    },
                  },
                  colors: ['#1976d2', '#2e7d32'],
                  stroke: { width: 3, curve: 'smooth' },
                  markers: { size: 6, hover: { size: 8 } },
                  dataLabels: {
                    enabled: true,
                    style: { fontSize: '12px', fontWeight: 'bold' },
                  },
                  legend: { position: 'top', fontSize: '14px', fontWeight: 500 },
                }}
                series={[
                  {
                    name: 'Surveys',
                    data: data?.monthly?.map((month) => month.surveys) || [],
                  },
                  {
                    name: 'Sessions',
                    data: data?.monthly?.map((month) => month.meetings) || [],
                  },
                ]}
                type="line"
                height={400}
              />
            </CardContent>
          </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card
          sx={{
            p: 3,
            boxShadow: '0px 2px 6px 0px rgba(13, 10, 44, 0.08)',
            borderRadius: 2,
            transition: 'all 0.3s ease-in-out',
            '&:hover': { boxShadow: '0px 4px 12px 0px rgba(13, 10, 44, 0.12)', transform: 'translateY(-2px)' },
          }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, p: 2, bgcolor: 'info.lighter', borderRadius: 1 }}>
              <CalendarTodayIcon sx={{ mr: 1, color: 'info.main' }} />
              <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.titles' }}>
                Recent Activity (Last 30 Days)
              </Typography>
            </Box>
            <CardContent sx={{ p: 3, pt: 0 }}>
              {Object.entries(data?.recentActivity || {}).map(([key, value], index) => (
                <Zoom in timeout={300 + index * 100} key={key}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mb={2}
                    p={2}
                    sx={{
                      backgroundColor: 'grey.50',
                      borderRadius: 2,
                      transition: 'all 0.3s ease-in-out',
                      '&:hover': {
                        backgroundColor: 'grey.100',
                        transform: 'translateX(4px)',
                        boxShadow: 2,
                      },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 500,
                        textTransform: 'capitalize',
                        color: '#333333 !important',
                      }}
                    >
                      {key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ color: '#0288d1 !important', fontWeight: 'bold' }}
                    >
                      {value}
                    </Typography>
                  </Box>
                </Zoom>
              ))}
            </CardContent>
          </Card>
      </Grid>
    </Grid>
  </Fade>
);

export default TrendsTab;

